/* eslint-disable @typescript-eslint/no-explicit-any */
import { CometChatCallsException, type ErrorModel } from './models';

export function isFalsy($false: any) {
  if ($false != null) {
    if (typeof $false == 'string') $false = $false.trim();
    if (typeof $false == 'object' && Object.keys($false).length === 0)
      $false = undefined;
  }
  const falsyvalues: any = [
    '',
    0,
    '0',
    false,
    null,
    'null',
    undefined,
    'undefined',
  ];
  return falsyvalues.includes($false);
}

function isObject(item: any) {
  return item && typeof item === 'object' && !Array.isArray(item);
}

export function mergeDeep(target: { [x: string]: any }, ...sources: any[]) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}

export function throwCommonException(
  errorCallback: (err: ErrorModel) => void,
  details: any,
) {
  try {
    const exceptionToThrow = new CometChatCallsException({
      code: 'GENERIC_EXCEPTION',
    });

    if (typeof details === 'string') {
      exceptionToThrow.message = details;
      exceptionToThrow.details = details;
    } else if ('toString' in details) {
      exceptionToThrow.message = details.toString();
      exceptionToThrow.details = details.toString();
    }
    if (errorCallback) {
      errorCallback(exceptionToThrow);
      return;
    }
    throw exceptionToThrow;
  } catch (error: any) {
    if (error?.toString?.()?.length > 0) {
      throw new CometChatCallsException({
        code: 'GENERIC_EXCEPTION',
        message: error.toString(),
      });
    }
    throw error;
  }
}
